import { useCallback } from 'react';
import { UserRoleDto } from '../../codegen/Swagger';
import useSecurityQuery from './useSecurityQuery';

const useSecurityForModule = (moduleName: string) => {
    const securityQuery = useSecurityQuery(moduleName);
    const data = securityQuery.data as UserRoleDto[];

    const hasRightForMethod = useCallback(
        (methodName: string) => {
            if (!data || !data.length) return false;

            for (const security of data) {
                if (security.module?.methods && security.module?.methods.length > 0)
                    for (const method of security.module.methods) {
                        if (method.code === methodName) return true;
                    }
            }

            return false;
        },
        [data],
    );

    const hasRightForMethodByDataScope = useCallback(
        (methodName: string, dataScopeName: string, valueId: number) => {
            const existsMethod = hasRightForMethod(methodName);
            let existsDataScope = false;
            if (!existsMethod) return false;

            for (const security of data) {
                if (security?.userRoleDataScopes && security?.userRoleDataScopes.length > 0)
                    for (const dataScope of security.userRoleDataScopes) {
                        if (dataScope.dataScopeName === dataScopeName && dataScope.valueId === valueId) return true;
                        if (dataScope.dataScopeName === dataScopeName) existsDataScope = true;
                    }
            }

            return existsMethod && !existsDataScope;
        },
        [data, hasRightForMethod],
    );

    return { securityQuery, hasRightForMethod, hasRightForMethodByDataScope, hasMethod: hasRightForMethod };
};

export default useSecurityForModule;
